import getActivePageId from './active-page-id';
import getAssetsUrl from './get-assets-url';
import getBusinessCategory from './business-category';
import getBusinessDescription from './business-description';
import getInitialSetupCompleted from './initial-setup-completed';
import getHomePage from './home-page';
import getOwnerId from './owner-id';
import getPage from './page';
import getPages from './pages';
import getSettings from './settings';
import getSite from './site';
import getSiteId from './site-id';
import getSiteName from './site-name';
import getSiteProperties from './site-properties';
import getUsedBlocks from './used-blocks';
import getUserEmails from './user-emails';
import getPageTemplateId from './page-template-id';
import getSiteProgressChecklist from './site-progress-checklist';
import getUpdatedAt from './updated-at';
import getUsedCustomColors from './used-custom-colors';
import getLastAppliedMigrationId from './get-last-applied-migration-id';
import getCreatedWithCleanUrlsDisabled from './get-created-with-clean-urls-disabled';
import getCleanUrlsEnabled from './clean-urls-enabled';
import getRedirects from './redirects';
import getMultilingualIntroShown from './get-multilingual-intro-shown';
import getIntegrations from './integrations';
import getInitialSettingsApplied from './initial-settings-applied';

export default {
  getActivePageId,
  getPageTemplateId,
  getAssetsUrl,
  getBusinessCategory,
  getBusinessDescription,
  getHomePage,
  getInitialSetupCompleted,
  getOwnerId,
  getPage,
  getPages,
  getSettings,
  getSite,
  getSiteId,
  getSiteName,
  getSiteProperties,
  getUsedBlocks,
  getUserEmails,
  getSiteProgressChecklist,
  getUpdatedAt,
  getUsedCustomColors,
  getLastAppliedMigrationId,
  getCreatedWithCleanUrlsDisabled,
  getCleanUrlsEnabled,
  getRedirects,
  getMultilingualIntroShown,
  getIntegrations,
  getInitialSettingsApplied,
};
